import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import { dayjs } from '@mobi/utils/date'

type OutcomeStatus = KambiHistoryCoupon['outcomes'][0]['status']

export function shouldProvideLinkToEvent({
  outcomeStatus,
  eventStartTime,
}: {
  outcomeStatus: OutcomeStatus
  eventStartTime: string | null
}): boolean {
  const hasNotStarted = !!eventStartTime && dayjs().isBefore(eventStartTime)
  const isLinkableOutcome = outcomeStatus === 'OPEN' || outcomeStatus === 'NOT_SET'

  return isLinkableOutcome && hasNotStarted
}
